import type en from '../en/starlink'
import type { Translation } from '../types'

/** Starlink: the terminals, a site's and an event's cards, the business account */
const starlink: Translation<typeof en> = {
  "starlink.title": "Terminaux Starlink",
  "starlink.subtitle": "Les terminaux Starlink de l'entreprise : leur site ou événement, en ligne, les données utilisées et leur service",
  "starlink.search": "Rechercher des terminaux Starlink",
  "starlink.refresh": "Actualiser",
  "starlink.refreshed": "Comptes Starlink lus",
  "starlink.refreshFailed": "Les comptes Starlink n'ont pas été lus",
  "starlink.addByKit": "Ajouter par numéro de kit",
  "starlink.addHint": "Un terminal avec un abonnement personnel, sans compte professionnel : il affiche ce que Velanox en sait — son site et son article de location.",
  "starlink.kitSerial": "Numéro de kit",
  "starlink.nickname": "Nom (facultatif)",
  "starlink.add": "Ajouter",
  "starlink.added": "Starlink ajouté",
  "starlink.addFailed": "Starlink non ajouté",
  "starlink.none": "Aucun terminal Starlink pour l'instant. Ajoutez le compte professionnel de l'entreprise dans Paramètres de l'entreprise → Connexions, ou ajoutez un terminal par son numéro de kit.",
  "starlink.col.terminal": "Terminal",
  "starlink.col.site": "Site ou événement",
  "starlink.col.online": "En ligne",
  "starlink.col.data": "Données",
  "starlink.col.service": "Service",
  "starlink.online": "En ligne",
  "starlink.offline": "Hors ligne",
  "starlink.lastRead": "Dernière lecture {when}",
  "starlink.notRead": "Pas encore lu",
  "starlink.noAccount": "Aucun compte",
  "starlink.notListed": "N'est plus dans son compte",
  "starlink.data": "{used} sur {plan} Go",
  "starlink.dataNoLimit": "{used} Go",
  "starlink.serviceOn": "Activé",
  "starlink.serviceOff": "Désactivé",
  "starlink.serviceUnknown": "Inconnu",
  "starlink.switching": "Basculement en cours…",
  "starlink.event": "Événement : {name}",
  "starlink.linkToSite": "Lier à un site",
  "starlink.site": "Site",
  "starlink.noSite": "Aucun site",
  "starlink.linked": "Starlink lié",
  "starlink.linkFailed": "Starlink non lié",
  "starlink.save": "Enregistrer",
  "starlink.remove": "Supprimer",
  "starlink.removeConfirm": "Supprimer {name} ? Un terminal encore dans son compte revient à la prochaine lecture, sans site.",
  "starlink.removed": "Starlink supprimé",
  "starlink.removeFailed": "Starlink non supprimé",
  "starlink.card.lastSeen": "Vu pour la dernière fois {when}",
  "starlink.card.neverSeen": "Jamais reçu de nouvelles",
  "starlink.card.alerts": "L'antenne signale : {alerts}",
  "starlink.card.data": "Données de ce cycle de facturation",
  "starlink.card.noLimit": "Son abonnement n'a pas de limite de données",
  "starlink.card.noData": "Aucune consommation de données connue",
  "starlink.card.service": "Service",
  "starlink.card.onConfirm": "Activer le service de ce Starlink ? Il peut être facturé.",
  "starlink.card.offConfirm": "Désactiver le service de ce Starlink ?",
  "starlink.card.switched": "Service basculé",
  "starlink.card.switchFailed": "Service non basculé",
  "starlink.card.inApp": "Basculez-le dans l'application Starlink : son abonnement ne peut pas être mis en pause d'ici.",
  "starlink.card.pending": "Starlink n'a pas encore pris en compte le basculement : il est retenté toutes les 5 minutes.",
  "starlink.card.noAccount": "Aucun compte professionnel : utilisez l'application Starlink pour sa consommation de données et son service.",
  "starlink.eventCard.none": "Aucun terminal Starlink sur cet événement.",
  "starlink.eventCard.switchedOn": "Activé",
  "starlink.eventCard.switchedOff": "Désactivé",
  "starlink.eventCard.notTaken": "non pris en compte par Starlink",
  "starlink.eventCard.withEvent": "avec l'événement",
  "starlink.eventCard.by": "par {name}",
  "starlink.eventCard.noSwitches": "Pas encore basculé pour cet événement",
  "starlink.account.title": "Compte professionnel Starlink",
  "starlink.account.intro": "L'ID client et le secret d'un compte de service du compte professionnel Starlink de l'entreprise. Velanox lit ses terminaux toutes les 5 minutes et bascule leur service avec vos événements.",
  "starlink.account.name": "Nom",
  "starlink.account.clientId": "ID client",
  "starlink.account.clientSecret": "Secret client",
  "starlink.account.secretKept": "Laissez vide pour conserver le secret",
  "starlink.account.save": "Tester et enregistrer",
  "starlink.account.saved": "Compte Starlink enregistré",
  "starlink.account.terminals": "Terminaux",
  "starlink.edit": "Modifier",
  "starlink.saved": "Starlink enregistré",
  "starlink.saveFailed": "Starlink non enregistré",
  "starlink.dish.title": "Antenne Starlink",
  "starlink.dish.auto": "Automatique",
  "starlink.dish.wan": "Seulement {wan}",
  "starlink.dish.off": "Désactivé",
  "starlink.dish.lookAgain": "Chercher à nouveau",
  "starlink.dish.looking": "Recherche…",
  "starlink.dish.found": "Trouvée sur {wan}",
  "starlink.dish.notFound": "Aucun Starlink trouvé derrière ce routeur",
  "starlink.dish.failed": "Les règles n'ont pas pu être écrites : {reason}",
  "starlink.dish.turnedOff": "Velanox ne cherche pas d'antenne Starlink derrière ce routeur",
  "starlink.dish.notChanged": "Le réglage de l'antenne Starlink n'a pas été modifié",
  "starlink.dish.block": "Antenne",
  "starlink.dish.signalOk": "Signal bon",
  "starlink.dish.signalLow": "Signal faible",
  "starlink.dish.obstructed": "Obstruée {pct} %",
  "starlink.dish.obstructedNow": "obstruée maintenant",
  "starlink.dish.speed": "Descendant {down} · Montant {up} Mbit/s",
  "starlink.dish.latency": "Latence {ms} ms",
  "starlink.dish.drop": "{pct} % des pings perdus",
  "starlink.dish.stowed": "Repliée",
  "starlink.dish.reachedVia": "Atteinte via {site}",
  "starlink.dish.notReachedSince": "Non atteinte depuis {when}",
  "starlink.dish.notReached": "Non atteinte",
  "starlink.dish.reboot": "Redémarrer",
  "starlink.dish.stow": "Replier",
  "starlink.dish.unstow": "Déplier",
  "starlink.dish.rebootConfirm": "Redémarrer cette antenne ? Sa connexion est coupée pendant quelques minutes.",
  "starlink.dish.stowConfirm": "Replier cette antenne ? Elle se met à plat et sa connexion s'arrête.",
  "starlink.dish.unstowConfirm": "Déplier cette antenne ?",
  "starlink.dish.done": "Envoyé à l'antenne",
  "starlink.dish.actionFailed": "L'antenne ne l'a pas fait",
}

export default starlink
